import React, {useCallback, useEffect, useMemo, useState} from 'react'
import { useHistory } from 'react-router';
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {TopBarRedesigned} from "../../../components/TopBarRedesigned";
import {
    Page,
    StatusBox,
} from "../ShiftDetailPage/ShiftDetail.styles";
import styles from "../ShiftDetailPage/ShiftDetail.module.scss";

import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";

import {
    convertDentalOfficeStatus,
    AccordionExpandIcon,
    CompleteShiftModal, DistanceComponent,
} from "../ShiftDetailPage/components";
import Api from "../../../api";
import {exitReact} from "utils";
import _ from "lodash";
import useActionApi from "../../../hooks/useActionApi";
import {usePersistedState} from "../../../hooks";
import {HygienistProps, HygienistScoreProps} from "utils/types";
import {entities} from "../../../reduxStore";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

import {
    CheckMark,
    ConfirmedJobBox,
    DescriptionContainer,
    HeaderDescription,
    LeftContainer,
    SafetyGuidelines,
    Subtitle,
    TitleContainer,
    Value,
    LinkButton, CompleteShiftBox, Link, CancelOffer, CancelOfferBox,
} from "./ConfirmedOffer.styles";
import { ActionButtons, ShiftDetails } from './components';

dayjs.extend(isToday)


const ConfirmedOfferPage = () => {
    const [trackData, setTrackData] = useState<any>(null);
    const [updatingJob, setUpdatingJob] = useState<boolean>(false);

    const history = useHistory();
    const {jobId, job: jobData } = history.location.state as any
    const [job, setJob] = useState(jobData || {} as any)
    const [isFavouriteDentist, setFavouriteDentist] = useState<boolean>(jobData?.isFavouriteDentist || false)

    const hygienist = usePersistedState<HygienistProps>({
        entityName: entities.hygienist
    })[0];

    const offer = useMemo(() => {
        if(!_.isEmpty(job))
            return job?.partialOffers?.findLast((offer: any) => offer.hygienistId === hygienist.id)
    }, [job]);

    const [getJobDetailsLoading, , getJobDetails] = useActionApi({
        apiMethod: Api.getJobDetails,
        onSuccess: (jobObj: any) => {
            if(_.isEmpty(jobObj)) return
            setJob(jobObj)
        },
    });

    const [checkFavouriteLocationLoading, , checkFavouriteLocation] = useActionApi({
        apiMethod: Api.checkFavouriteLocation,
        onSuccess: (data: any) => {
            setFavouriteDentist(data.isFavouriteDentist)
        },
    });

    useEffect(() => {
        if(_.isEmpty(jobData) && jobId) {
            getJobDetails(jobId)
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(job)) {
            setTrackData({
                isInstabookEnabled: !!job.Instabook,
                recommendedHourlyRate: job.proposedRate,
                currencyCode: job.location.country ? 'USD' : 'CAD',
                dentalOfficeLocationId: job.locationId,
                dentalOfficeId: job.dentistId,
                dentalOfficeStatus: convertDentalOfficeStatus(job.location.status),
                shiftStartDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedStart).toISOString(),
                shiftEndDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedEnd).toISOString(),
                shiftId: job.shifts[0].id,
                shiftPostDate: new Date(job.postedOn).toISOString(),
            })
            checkFavouriteLocation(job.locationId)
        }
    }, [job]);

    const goChat = useCallback(() => {
        exitReact('chat', job, 'fwd', null)
    }, [job]);

    const [cancellationStatsProps, setCancellationStatsProps] = useState<HygienistScoreProps | null>(null);
    const [statsLoading, , getStats] = useActionApi({
        apiMethod: Api.calculateCancellationStats,
        onSuccess: (data: HygienistScoreProps) => {
            setCancellationStatsProps(data)
        },
    })

    useEffect(() => {
        getStats({jobId})
        return;
    }, []);

    const goCancelJob = useCallback(() => {
            history.push('hygienistCancelJob', {job, hygienist, cancellationStatsProps})
    }, [job, hygienist, cancellationStatsProps]);

    const isGuaranteedRate = useMemo(() => !!job?.ghr, [job])
    const hourlyRate = useMemo(() => {
        return isGuaranteedRate ? `$${job.ghr}/hr Guaranteed`
            : `$${offer?.hourlyRate || job?.hourlyRate}/hr`
    }, [isGuaranteedRate, job, offer]);

    const handleDocumentView = useCallback(() => {
        if (!job?.location?.photoUrl) return;
        try {
            const fileUrl = job.location.photoUrl;            
            // @ts-ignore 
            if (window.cordova) {
                    // @ts-ignore 
                    cordova.InAppBrowser.open(
                        fileUrl,
                        '_system',
                        'location=yes'
                    );
            } else {
                window.open(fileUrl, '_blank');
            }
        } catch (error) {
            console.error('Error handling document:', error);
            window.location.href = job.location.photoUrl;
        }
    }, [job?.location?.photoUrl]);

    const hasDocument = !!job?.location?.photoUrl;

    return (<>
        <TopBarRedesigned
            title={'Booked/Confirmed Shift'}
            onBack={() => {
                history.push('loading')
                exitReact('home')
            }}
        />
        {!_.isEmpty(job) ? <Page>
            <HeaderDescription>{hygienist?.firstName}, you are confirmed for your shift, {job.location.practiceName} and
                their patients are looking forward to seeing you. Here are the details:</HeaderDescription>
            <TitleContainer hasDocument={hasDocument}>
                <LeftContainer>
                    <ConfirmedJobBox>
                        <StatusBox>
                            <EventAvailableIcon className={styles.confirmedShiftIcon}/>
                            Confirmed
                        </StatusBox>
                    </ConfirmedJobBox>

                    <Value>{job.location.practiceName}</Value>

                    <Subtitle style={{opacity: 1}}>
                        {`${job.location.address}, ${job.location.city}, ${job.location.province} ${job.location.postalCode}`}
                    </Subtitle>

                    <ActionButtons job={job} goChat={goChat} handleDocumentView={handleDocumentView} />
                </LeftContainer>

                <ShiftDetails job={job} hourlyRate={hourlyRate} />
            </TitleContainer>

            <AccordionExpandIcon job={job}/>

            <SafetyGuidelines>
                <CheckMark/>
                <Subtitle>
                    This office has confirmed they meet or exceed the {job.location.province} guidelines for workplace safety and
                    infection control.
                </Subtitle>
            </SafetyGuidelines>

            <CompleteShiftBox>
                <LinkButton
                    href={'https://support.tempstars.com/hc/en-us/articles/360051064813-PPE-and-Infection-Control-for-Temping-Shifts'}
                    target="_system"
                    className={"external no-fastclick"}
                >TempStars Workplace Safety Guarantee</LinkButton>
                <CompleteShiftModal job={job} history={history} trackData={trackData}/>
            </CompleteShiftBox>

            <CancelOfferBox>
                <CancelOffer
                    variant="outlined"
                    color="secondary"
                    size="large"
                    id="continue-button"
                    className="no-fastclick"
                    onClick={goCancelJob}
                >Cancel Shift</CancelOffer>
                <LinkButton
                    href={'https://support.tempstars.com/hc/en-us/articles/360046619234-Cancelling-Shifts-Hygienists-Assistants'}
                    target="_system"
                    className={"external no-fastclick"}>
                    TempStars Cancellation and Membership Review Policy
                </LinkButton>
            </CancelOfferBox>

            <DescriptionContainer>
                <Subtitle>
                    <b>Important Notes</b>
                </Subtitle>
                <Subtitle>
                    <b>Lunch and Breaks:</b> For most offices, lunch and breaks are unpaid,
                    and offices do their best to provide a lunch break,
                    but the nature of providing dental care to a full schedule can make this unpredictable.
                    If you have concerns about a lunch break, be sure to ask the office owner or manager, or reach out
                    to TempStars Support
                </Subtitle>
                <Subtitle>
                    <b>Start Time:</b> This is the time the office indicated they need you at the office,
                    changed into scrubs and ready for clinical work. End of shift can be a bit variable.
                    If you need to end your shift absolutely no later than the scheduled end time,
                    tell the office manager at the beginning of your shift, so they can accommodate you.
                </Subtitle>
                <Subtitle>
                    <b>Directly Arranged Shifts:</b> If {job.location.practiceName} arranges any shifts with you directly outside the
                    app,
                    record it in the "Book/Record Shift" button in the app.
                    It's our policy to keep your membership in good standing and is the only way to benefit from
                    TempStars guarantees and service.
                    <Link
                        href={'https://support.tempstars.com/hc/en-us/articles/360051064813-PPE-and-Infection-Control-for-Temping-Shifts'}
                        target="_system"
                        className={"external no-fastclick"}
                    >(TempStars Workplace Safety Guarantee)</Link>
                    <Link
                        href={'https://www.tempstars.com/direct_payment'}
                        target="_system"
                        className={"external no-fastclick"}
                    >(TempStars Payment Guarantee)</Link>
                    <Link
                        href={'https://www.tempstars.com/short-notice'}
                        target="_system"
                        className={"external no-fastclick"}
                    >(TempStars Short Notice Cancellation Guarantee)</Link>
                </Subtitle>
            </DescriptionContainer>

        </Page> : null}

        <FixedLoader
            loading={getJobDetailsLoading || checkFavouriteLocationLoading || updatingJob}
        />
    </>)
}

export default React.memo(ConfirmedOfferPage);
